import L from 'leaflet'

/**
 * Manages tile layers for the map, including backyard overlay
 * @param {L.Map} map - Leaflet map instance
 */
export function initializeMapLayers(map) {
  if (!map) return

  // Backyard overlay bounds (converted from RT90 EPSG:5850)
  const backyardBounds = [
    [59.8531611, 17.3533935], // Southwest corner (south, west)
    [59.8547779, 17.3541135]  // Northeast corner (north, east)
  ]

  // Add backyard overlay as image layer
  const backyardOverlay = L.imageOverlay('/tiles/backyard/overlay.png', backyardBounds, {
    zIndex: 100,
    opacity: 0.9,
    interactive: false
  }).addTo(map)

  console.log('✓ Backyard overlay image layer added')
  return backyardOverlay
}
